import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router/index'
import iView from 'iview'

import Directive from './assets/js/directives'
import store from './store/index'
import DateFormat from './assets/js/dateFormat'
import { yznReq } from './assets/js/yznhttp'
import Popup from './components/popup'
// 样式
import 'iview/dist/styles/iview.css'
import './assets/css/reset.css'
import './assets/css/common.css'
import './assets/css/icon.css'
import './assets/css/lib/cropper.css'
// js
import './assets/js/qiniu.min'
import './assets/js/qnUpload'

import * as filters from './assets/js/filters'
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

// 视频播放器
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)

// 图片预览
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)

Vue.config.productionTip = false
Vue.use(iView);
Vue.use(Directive);
Vue.prototype.yznReq = yznReq;
Vue.prototype.DateFormat = DateFormat;

// Vue.prototype.$qnCropUpload = Popup.qiniuCropUpload.install;
Vue.prototype.$confirm = Popup.confirm;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js